import { Get, Post, PostFormData, Put,Delete } from "../Request/Api";

export default {
  state: {
    pageNum: null,
    isSearch: '',
    isbackForum: false,
    Forums: [],
    PreviewForum: null,
    ForumComments: [],
    ForumCategories: [],
    ForumWebCategories: [],
    ForumsAlsoCheckOut: [],
    forumFilter:null
  },
  getters: {
    GetForumFilter(state: any) {
      return state.forumFilter;
    },
    GetForumCategories(state: any) {
      return state.ForumCategories;
    },
    GetForumWebCategories(state: any) {
      return state.ForumWebCategories;
    },
    GetForums(state: any) {
      return state.Forums;
    },
    GetForumslatest(state :any )
    {
      return state.Forums;
    },
    GetForumsAlsoCheckOut(state: any) {
      return state.ForumsAlsoCheckOut;
    },
    GetPreviewForum(state: any) {
      return state.PreviewForum;
    },
    GetForumComments(state: any) {
      return state.ForumComments;
    },
  },
  actions: {
    async GetForums({ commit }: any, payload: any) {
      return await Get(
        `Forum/GetForumsWeb/${payload.page}?pageSize=${payload.pageSize}&search=${payload.search}&userID=${payload.userID}&filters=${payload.filters}`
      ).then((res: any) => {
        commit("SetForums", res.data.Data ? res.data.Data.List : []);
        return res.data.Data;
      });
    },
    async GetForumslatest({ commit }: any, payload: any) {
      return await Get(
        `Forum/GetForums/1?pageSize=3`
      ).then((res: any) => {
        commit("SetForums", res.data.Data ? res.data.Data.List : []);
        return res.data.Data;
      });
    },
    async GetForumsAlsoCheckOut({ commit }: any, payload: any) {
      return await Get(
        `Forum/GetForumsAlsoCheckOut/${payload.page ?? 1}?pageSize=${
          payload.pageSize ?? 9
        }&search=${payload.search ?? ""}&filters=${payload.filters ?? ""}`
      ).then((res: any) => {
        commit(
          "setForumsAlsoCheckOut",
          res.data.Data ? res.data.Data.List : []
        );
        return res.data.Data;
      });
    },

    async GetForumCategories({ commit }: any, payload: any) {
      return await Get(`Forum/GetForumCategories`).then((res: any) => {
        commit("SetForumCategories", res.data.Data);
      });
    },
    async GetForumWebCategories({ commit }: any, payload: any) {
      return await Get(`Forum/GetWebForumCategories/${payload.userID}`).then((res: any) => {
        commit("SetForumWebCategories", res.data.Data);
      });
    },
    async GetForumById({ commit }: any, payload: any) {
      return await Get(`Forum/GetForumById/${payload}`).then((res: any) => {
        commit("SetPreviewForm", res.data.Data);
      });
    },
    async DeleteForumComment({ commit }: any, payload: any) {
      return await Delete(`Forum/DeleteForumComment/${payload}`).then((res: any) => {
        return res;
      });
    },
    async DeleteForumCommentReply({ commit }: any, payload: any) {
      return await Delete(`Forum/DeleteForumCommentReply?ReplyCommentId=${payload}`).then((res: any) => {
        return res;
      });
    },
    async EditForumCommentReply({ commit }: any, payload: any) {
      return await Put(`Forum/EditForumCommentReply`,payload).then((res: any) => {
        return res;
      });
    },
    async ToggleForumFollowBoard({ commit }: any, payload: any) {
      return await Post("Forum/ToggleForumFollowBoard", payload).then(
        (res: any) => {
          return res.data;
        }
      );
    },
    async AddForumView({ commit }: any, payload: any) {
      return await Post("Forum/AddForumView", payload).then((res: any) => {
        return res.data;
      });
    },

    async EditForum({ commit }: any, payload: any) {
      return await Put("Forum/EditForum", payload).then((res: any) => {
        return res.data;
      });
    },
    async CreateForum({ commit }: any, payload: any) {
      return await PostFormData("Forum/AddForum", payload).then((res) => {
        console.log(res);
        return res.data;
      });
    },
    async AddForumComment({ commit }: any, payload: any) {
      return await Post("Forum/AddForumComment", payload).then((res: any) => {
        return res.data;
      });
    },
    async AddForumCommentReply({ commit }: any, payload: any) {
      return await Post("Forum/AddForumCommentReply", payload).then(
        (res: any) => {
          return res.data;
        }
      );
    }, 
    async UploadImage({ commit }:any, payload:any) {
      var form = new FormData();
      form.append("File", payload);
      return PostFormData("Forum/UploadForumImages", form).then((res) => {
        // return process.env.VUE_APP_IMG_URL + res.data.Data;
        return res.data.Data;
      });
    },
    async GetForumComments({ commit }: any, payload: any) {
      return await Get(
        `Forum/GetForumCommentsWeb/${payload.page}?pageSize=${payload.pageSize}&forumId=${payload.forumId}`
      ).then((res: any) => {
        commit("SetForumComments", res.data.Data.List);
        return res.data.Data;
      });
    },
    async ForumFilter({ commit }: any, payload: any) {
      commit("SetForumFilter",payload)
    }, 
  },
  mutations: {
    SetPageNum(state, pageNum) {
      state.pageNum = pageNum;
    },
    SetForumFilter(state: any, payload: any){
      state.forumFilter = payload
    },
    SetForums(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.ImgVid =
          x.ImgVid != null && x.ImgVid != undefined && x.ImgVid != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.ImgVid
            ? x.ImgVid
            : x.ImgVid;
        x.SubmittedByProfileImage =
          x.SubmittedByProfileImage != null &&
          x.SubmittedByProfileImage != undefined &&
          x.SubmittedByProfileImage != ""
            ? x.SubmittedByProfileImage
            : x.SubmittedByProfileImage;
        return x;
      });
      state.Forums = payload;
    },
    setForumsAlsoCheckOut(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.ImgVid =
          x.ImgVid != null && x.ImgVid != undefined && x.ImgVid != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.ImgVid
            ? x.ImgVid
            : x.ImgVid;
        x.SubmittedByProfileImage =
          x.SubmittedByProfileImage != null &&
          x.SubmittedByProfileImage != undefined &&
          x.SubmittedByProfileImage != ""
            ? x.SubmittedByProfileImage
            : x.SubmittedByProfileImage;
        return x;
      });
      state.ForumsAlsoCheckOut = payload;
    },
    SetForumComments(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.SubmittedByProfileImage =
          x.SubmittedByProfileImage != null &&
          x.SubmittedByProfileImage != undefined &&
          x.SubmittedByProfileImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.SubmittedByProfileImage
            ? x.SubmittedByProfileImage
            : x.SubmittedByProfileImage;
        return x;
      });
      state.ForumComments = payload;
    },
    SetPreviewForm(state: any, payload: any) {
      if (payload) {
        payload.ImgVid =
          payload.ImgVid != null &&
          payload.ImgVid != undefined &&
          payload.ImgVid != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + payload.ImgVid
            ? payload.ImgVid
            : payload.ImgVid;
        payload.SubmittedByProfileImage =
          payload.SubmittedByProfileImage != null &&
          payload.SubmittedByProfileImage != undefined &&
          payload.SubmittedByProfileImage != ""
            ? payload.SubmittedByProfileImage
            : payload.SubmittedByProfileImage;
        state.PreviewForum = payload;
      }
    },
    SetForumCategories(state: any, payload: any) {
      state.ForumCategories = payload;
    },
    SetForumWebCategories(state: any, payload: any) {
      state.ForumWebCategories = payload;
    },
  },
};
